<template>
  <div v-if="page">
    <page-header
      :header="page.title"
      :subheader="page.intro"
    >
      <div class="flex items-start">
        <router-link
          v-if="profile.type <= 2"
          :to="`/admin/${pageType}/${page.slug}`"
          class="no-underline text-black inline-block bg-white rounded-lg p-4 uppercase text-sm font-medium align-bottom"
        >
          <i class="far fa-edit fa-fw fa-lg" />
          Edit
        </router-link>
      </div>
    </page-header>

    <grs-registration-modal :page="page" />

    <div v-if="tabsToDisplay.length > 1" class="mb-8 lg:mb-0" :class="showOtherModules === false ? 'opacity-50' : ''">
      <responsive-secondary-menu :menu-items="tabsToDisplay" v-model="selectedTab" :item-disabled="showOtherModules"/>
    </div>

      <div class="w-full flex justify-end" :class="{ 'mt-16': tabsToDisplay.length == 1 }">
        <tabulated-pages :tabs="tabsToDisplay" :active="selectedTab" class="w-full">
          <div slot="page" class="flex flex-wrap -mx-4">
            <div class="w-full lg:w-3/5 px-4 flex flex-col">
              <div class="bg-white rounded-lg p-6 pt-0 mt-6">
                <div class="flex items-center border-b mb-6 pb-2">
                  <div class="w-32 h-32 p-4 -mt-12 mb-2 rounded-lg relative flex-no-shrink"
                      :class="page.icon_color ? page.icon_color : 'bg-tertiary'">
                    <!-- <i v-if="page.icon" class="fas fa-5x text-white" :class="`fa-${page.icon}`"></i> -->
                    <icon v-if="page.icon" :name="page.icon" :class="page.icon_text_color" />
                    <icon v-else name="information_circle" class="text-white" />
                    <!-- <i v-else class="fas fa-5x text-white fa-file-alt"></i> -->
                  </div>
                  <div class="w-full">
                    <h3 class="mx-6 text-3xl font-medium">
                      {{ contentTitle }}
                    </h3>
                  </div>
                  <div v-if="system.external_data.plan === true">
                    <div v-show="!page.available_plan.hidePlanIcons">
                      <pop-over-content v-if="(selectedOffice.network_id === 2 && returnIcon(page) !='members-hub-tick')" :message="returnIcon(page)" class="flex-no-shrink w-10 h-10 -mt-16">
                        <icon :name="returnIcon(page)" :class="(page.available_plan[selectedOffice.role] === 'Included' ? 'text-green' : '')"/>
                      </pop-over-content>
                      <div v-else-if="selectedOffice.network_id === 2" class="flex-no-shrink w-10 h-10 -mt-16">
                        <icon :name="returnIcon(page)" :class="(page.available_plan[selectedOffice.role] === 'Included' ? 'text-green' : '')"/>
                      </div>
                    </div>
                  </div>
                  <div class="flex mx-auto">
                    <div v-if="page.video_url" class="w-12 h-12 rounded-full border border-tertiary text-center">
                      <a :href="page.video_url" target="_blank">
                        <icon name="video_2" class="w-12 h-12 p-1 text-tertiary"/>
                      </a>
                    </div>
                    <div v-if="page.page_turner_url" class="ml-4 w-12 h-12 rounded-full border border-tertiary text-center">
                      <a :href="page.page_turner_url" target="_blank">
                        <icon name="page_turners" class="w-12 h-12 p-2 text-tertiary"/>
                      </a>
                    </div>
                    <div v-if="page.website_url" class="ml-4 w-12 h-12 rounded-full border border-tertiary text-center">
                      <a :href="page.website_url" target="_blank">
                        <icon name="webinar" class="w-12 h-12 p-2 text-tertiary"/>
                      </a>
                    </div>
                  </div>
                  <span
                    v-if="!page.published"
                    class="inline-block rounded-lg self-start ml-auto mt-4 -mr-2 p-1 px-4 bg-primary text-white text-xs uppercase"
                  >
                    Draft
                  </span>
                </div>

                <div>
                  <div
                    v-for="(block, index) in page.content"
                    :key="index"
                    :class="{ 'mb-6 pb-4 border-b': index < (page.content.length - 1) }"
                  >
                  <div v-html="block.settings.content" class="leading-normal page-content"></div>
                </div>
              </div>
            </div>
          </div> <!-- end content -->
          <div class="w-full lg:w-2/5 px-4 mt-6">
            <div v-if="system.external_data.plan === true">
              <div v-for="(module, index) in pageModules" :key="index">
                <component v-if="setVisibilityForFirstModule(index) === true"  :is="module.type" :page="page" :module="module" class="mb-6"  />
              </div>
            </div>
            <div v-else>
                <div v-for="(module, index) in pageModules" :key="index">
                  <component :is="module.type" :page="page" :module="module" class="mb-6"  />
                </div>
              </div>
          </div> <!-- end modules -->
        </div>
        <div v-for="(productPage, index) in productPages" :key="index" :slot="productPage.id">
          <div v-bind:is="productPage.view" :page="page">
            <p>Could not load component.</p>
          </div>
        </div>
        <div slot="product-module-settings">
          <product-settings :page="page" :settings="settingsTabs" :icon="page.icon"></product-settings>
        </div>
      </tabulated-pages>
    </div>
  </div>
  <div v-else-if="!page && !pagesLoading" class="w-full flex flex-col md:flex-row items-center">
    <div class="w-full md:w-1/2 text-center">
      <h1 class="text-5xl font-thin mb-6 text-center">
        Urm...
      </h1>
      <h2 class="text-3xl font-normal mb-12">
        Page not found
      </h2>
      <router-link to="/" class="inline-block no-underline text-black text-1xl font-normal bg-white rounded shadow px-4 py-3 hover:shadow-none">
        Take me home
      </router-link>
    </div>
  </div>
  <loader v-else />

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { find, head, includes } from 'lodash'
import api from '@/http'
import productModules from '@/product-modules'
import settings from '@/views/product-modules/Settings'
import { EventBus } from '@/EventBus'
import SimpleCta from '@/components/Link'
import CallToAction from '@/components/CallToAction'
import Media from '@/components/Media'
import LatestEzine from '@/components/LatestEzine'
import LatestPageTurner from '@/components/LatestPageTurner'
import ValuationMailer from '@/components/ValuationMailer'
import GoldMarketingPack from '@/components/GoldMarketingPack'
import DigitalHubLink from '@/components/DigitalHubLink'
import PageTurners from '@/components/PageTurners'
import Offerhive from '@/components/Offerhive'
import Insight from '@/components/Insight'
import FeeStreet from '@/components/FeeStreet'
import QrCodeModule from '@/components/QrCodeModule'
import CustomPrintModule from '@/components/CustomPrintModule'
import Discounts from '@/components/Discounts'
import Locked from '@/components/Locked'
import PopOverContent from '@/components/PopOverContent'
import Knowledgehub from '@/components/Knowledgehub'
import TicketEventBooking from '@/components/Events/TicketEventBooking'

export default {
  props: ['menuSlug', 'slug'],
  components: {
    ...productModules,
    productSettings: settings,
    SimpleCta,
    CallToAction,
    Media,
    LatestEzine,
    LatestPageTurner,
    ValuationMailer,
    GoldMarketingPack,
    DigitalHubLink,
    PageTurners,
    Offerhive,
    Insight,
    FeeStreet,
    QrCodeModule,
    CustomPrintModule,
    Locked,
    Discounts,
    PopOverContent,
    Knowledgehub,
    TicketEventBooking
  },
  data () {
    return {
      page: null,
      selectedTab: 'page',
      productPages: [],
      settingsTabs: [],
      loading: true,
      showDiscountModule: false,
      showLockedModule: false,
      showOtherModules: true,
      disableTabs: false
    }
  },

  computed: {
    ...mapState([
      'pages', 'profile', 'selectedOffice', 'pagesLoading', 'system'
    ]),

    pageType () {
      return includes(['partner', 'page', 'marketing-pack'], this.page.type) ? this.page.type : 'page'
    },

    contentTitle () {
      let content = head(this.page.content)

      if (!content) {
        return this.page.title
      }

      return content.title
    },
    tabsToDisplay () {
      const tabs = []

      tabs.push({
        // title: this.page ? this.page.title : 'About',
        title: 'About',
        id: 'page',
        icon: this.productPages.length > 0 ? (this.productPages[0].icon ? 'info-circle' : '') : ''
      })

      this.productPages.forEach(function (item) {
        tabs.push({
          title: item.title,
          icon: item.icon,
          id: item.id,
          badge: item.badge
        })
      })

      if (this.settingsTabs.length > 0) {
        tabs.push({
          title: 'Settings',
          id: 'product-module-settings',
          icon: 'cogs'
        })
      }

      return tabs
    },

    pageModules () {
      let output = []

      if (!this.page || !this.selectedOffice) {
        return output
      }

      for (let i = 0; i < this.page.modules.length; i++) {
        if (this.page.modules[i].permissions === null ||
          (this.page.modules[i].permissions.operator === 'contains' && this.selectedOffice.permissions.indexOf(this.page.modules[i].permissions.permission) >= 0) ||
          (this.page.modules[i].permissions.operator === 'not_contains' && this.selectedOffice.permissions.indexOf(this.page.modules[i].permissions.permission) === -1)) {
          output.push(this.page.modules[i])
        }
      }

      return output
    }
  },

  methods: {
    ...mapActions(['setPageLoading']),
    reset () {
      this.page = null
      this.selectedTab = 'page'
      this.productPages = []
      this.settingsTabs = []
      this.loading = true
      this.showDiscountModule = false
      this.showLockedModule = false
      this.showOtherModules = true
      this.disableTabs = false
    },
    loadPage () {
      this.setPageLoading(true)

      this.reset()
      this.page = find(this.pages, page => page.slug === this.slug)

      if (this.page) {
        this.loadProductModule()
      } else {
        this.setPageLoading(false)
      }

      if (this.$route.hash) {
        this.selectedTab = this.$route.hash.slice(1)
      }
    },
    loadProductModule () {
      if (!this.selectedOffice.id) {
        return
      }

      api.get(`pages/${this.page.slug}/product`, { params: { 'office_id': this.selectedOffice.id } })
        .then((response) => {
          this.productPages = response.data.tabs
          this.settingsTabs = response.data.settings
        })
        .finally(() => {
          this.setPageLoading(false)
          this.loading = false
        })
    },

    setTab (tab) {
      this.$set(this, 'selectedTab', tab)
    },
    returnIcon (page) {
      var icon = page.available_plan[this.selectedOffice.role]
      if (this.selectedOffice.role === 'Standard' && page.available_plan.Standard === 'Locked' && page.available_plan.Premium === 'Included' && page.available_plan.Enhanced === 'Included') {
        this.setModuleVisibility('locked-enhanced-premium')
        return 'locked-enhanced-premium'
      }
      if (this.selectedOffice.role === 'Legacy' && page.available_plan.Standard === 'Locked' && page.available_plan.Premium === 'Included' && page.available_plan.Enhanced === 'Included') {
        this.setModuleVisibility('locked-enhanced-premium')
        return 'locked-enhanced-premium'
      }
      if (this.selectedOffice.role === 'Legacy' && page.available_plan.Legacy === 'Locked' && page.available_plan.Standard === 'Included' && page.available_plan.Premium === 'Included' && page.available_plan.Enhanced === 'Included') {
        this.setModuleVisibility('locked-standard-enhanced-premium')
        return 'locked-standard-enhanced-premium'
      }
      if (this.selectedOffice.role === 'Standard' && page.product_module === 'App\\Members\\ProductModules\\AutoProspectingModule' && this.selectedOffice.aps_override === true) {
        icon = 'Included'
      }
      switch (icon) {
        case 'Included':
          icon = 'members-hub-tick'
          break
        case 'Discounted':
          icon = 'discount-all'
          break
        case 'Locked':
          icon = 'locked-premium'
          break
        default:
          break
      }
      this.setModuleVisibility(icon)
      return icon
    },
    setModuleVisibility (icon) {
      // var icon = this.returnIcon(page)
      switch (icon) {
        case 'members-hub-tick':
          this.showDiscountModule = false
          this.showLockedModule = false
          this.showOtherModules = true
          break
        case 'discount-all':
          this.showDiscountModule = true
          this.showLockedModule = false
          this.showOtherModules = true
          break
        case 'locked-enhanced-premium':
          this.showDiscountModule = false
          this.showLockedModule = true
          this.showOtherModules = false
          break
        case 'locked-standard-enhanced-premium':
          this.showDiscountModule = false
          this.showLockedModule = true
          this.showOtherModules = false
          break
        case 'locked-premium':
          this.showDiscountModule = false
          this.showLockedModule = true
          this.showOtherModules = false
          break
        default:
          break
      }
    },
    setVisibilityForFirstModule (index) {
      // check if the product is Locked
      let isItLocked = this.returnIcon(this.page)
      let lockedArray = ['locked-enhanced-premium', 'locked-standard-enhanced-premium', 'locked-premium']
      if (lockedArray.includes(isItLocked)) {
        if (index === 0) {
          return true
        }
        return false
      }
      if (index === 0) {
        if (this.page.available_plan.hideFirstModule === 'never') {
          return true
        }
        if (this.page.available_plan.hideFirstModule === 'standard') {
          if (this.selectedOffice.role === 'Standard') {
            return false
          }
          if (this.selectedOffice.role === 'Enhanced') {
            return false
          }
          if (this.selectedOffice.role === 'Premium') {
            return false
          }
          return true
        }
        if (this.page.available_plan.hideFirstModule === 'enhanced') {
          if (this.selectedOffice.role === 'Enhanced') {
            return false
          }
          if (this.selectedOffice.role === 'Premium') {
            return false
          }
          return true
        }
        if (this.page.available_plan.hideFirstModule === 'premium') {
          if (this.selectedOffice.role === 'Premium') {
            return false
          }
          return true
        }
      }
      return true
    }

  },
  created () {
    this.loadPage()
    EventBus.$on('page:change-tab', this.setTab)
  },

  beforeDestroy () {
    EventBus.$off('page:change-tab', this.setTab)
  },

  watch: {
    pages () {
      this.loadPage()
    },

    selectedOffice () {
      this.loadPage()
    },
    slug () {
      this.loadPage()
    }
  }
}
</script>

<style lang="scss">
.page-content {
  & p {
    @apply my-4;
  }
  & img {
    @apply m-2 mt-1 p-2 pt-1;
  }
}
</style>
